import React from 'react';
import Image from '../../atoms/Image';
import OutboundLink from '../../atoms/OutboundLink';
import FishermanLogoWhite from './fisherman-logo.svg';
import './FishermanBanner.css';
var defaultProps = {
  backgroundColor: 'black'
};
export default function FishermanBanner(props) {
  var backgroundColor = props.backgroundColor;
  return /*#__PURE__*/React.createElement("div", {
    className: "fisherman-banner",
    style: {
      backgroundColor: backgroundColor
    }
  }, /*#__PURE__*/React.createElement(OutboundLink, {
    href: "https://gofisherman.com/"
  }, /*#__PURE__*/React.createElement("span", null, "Powered by"), /*#__PURE__*/React.createElement(Image, {
    className: "fisherman-logo",
    src: FishermanLogoWhite
  })));
}
FishermanBanner.defaultProps = defaultProps;